import React, { useContext, useMemo } from 'react';
import {
  BusinessDataFormContext,
  IDefinedBusinessDataFormContext,
} from '../BusinessDataForm';

interface IProps {
  disabled: boolean;
}

const ReadOnlyFormContextProvider: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const formContext = useContext(BusinessDataFormContext);

  const readOnlyFormContextValue = useMemo<
    IDefinedBusinessDataFormContext<any> | undefined
  >(
    () =>
      formContext
        ? {
            ...formContext,
            formState: { ...formContext.formState, editMode: false },
          }
        : undefined,
    [formContext]
  );

  if (readOnlyFormContextValue && !props.disabled) {
    return (
      <BusinessDataFormContext.Provider value={readOnlyFormContextValue}>
        {props.children}
      </BusinessDataFormContext.Provider>
    );
  } else {
    return <>{props.children}</>;
  }
};

export default ReadOnlyFormContextProvider;
